/**
 * @generated SignedSource<<562cfdee9b24aace2adef7ebfdc7ac83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestShippingQuoteForm_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly profile: {
    readonly firstName: string | null;
    readonly lastName: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"AddressSelector_user" | "RequestModalSelectProject_user">;
  readonly " $fragmentType": "RequestShippingQuoteForm_user";
};
export type RequestShippingQuoteForm_user$key = {
  readonly " $data"?: RequestShippingQuoteForm_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestShippingQuoteForm_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestShippingQuoteForm_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddressSelector_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestModalSelectProject_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cd142fb5aee4cc449b98b75363e6b14c";

export default node;
